import { Box, Flex } from "@zenchef/styled-system/jsx";
import { Text } from "../../typography/Text";
import {
  aromaMinitable,
  AromaMinitableVariantProps,
} from "@zenchef/styled-system/recipes";
import { cx } from "@zenchef/styled-system/css";

export interface Row {
  label: string;
  labelColor?: Parameters<typeof Text>[0]["color"];
  description?: string;
  secondaryDescription?: string;
  img?: React.ReactNode;
  value: React.ReactNode;
}

export interface Footer {
  label: string;
  value: string;
}

export interface MinitableProps extends AromaMinitableVariantProps {
  rows: Row[];
  footer?: Footer;
  className?: string;
}

export default function Minitable({
  rows,
  footer,
  className,
  ...propsWithVariants
}: MinitableProps) {
  const [variants, props] = aromaMinitable.splitVariantProps(propsWithVariants);
  const classes = aromaMinitable(variants);

  return (
    <Box className={cx(classes.root, className)} {...props}>
      {rows.map(
        (
          { label, labelColor, description, secondaryDescription, img, value },
          index,
        ) => (
          <Flex
            key={index}
            className={classes.row}
            data-has-secondary-description={!!secondaryDescription || undefined}
          >
            <Flex className={classes.leftColumn}>
              {!variants.stacked ? img : null}
              <Flex className={classes.labelContainer}>
                <Text
                  textStyle="paragraph.m.bold"
                  color={labelColor ?? "content.neutral.base.bold"}
                >
                  {label}
                </Text>
                {description ? (
                  <Text
                    textStyle="paragraph.s.regular"
                    color="content.neutral.base.subtlest"
                  >
                    {description}
                  </Text>
                ) : null}
                {secondaryDescription ? (
                  <Text
                    textStyle="paragraph.s.regular"
                    color="content.neutral.base.subtlest"
                  >
                    {secondaryDescription}
                  </Text>
                ) : null}
              </Flex>
            </Flex>
            <Flex
              className={classes.rightColumn}
              data-has-secondary-description={
                !!secondaryDescription || undefined
              }
            >
              {value}
            </Flex>
          </Flex>
        ),
      )}
      {footer ? (
        <Flex className={classes.footer}>
          <Text textStyle="paragraph.m.bold" color="content.neutral.base.bold">
            {footer.label}
          </Text>
          <Text textStyle="paragraph.m.bold" color="content.neutral.base.bold">
            {footer.value}
          </Text>
        </Flex>
      ) : null}
    </Box>
  );
}
